module.exports = __webpack_public_path__ + "static/media/Fresh_Grazel_TH2.52741887.png";